import {Component} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from "@angular/animations";
import {Toast, ToastPackage, ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-toaster-alert',
  templateUrl: './toaster-alert.component.html',
  styleUrl: './toaster-alert.component.scss',
  standalone:false,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 1,
      })),
      transition('inactive <=> active', animate('1000ms ease-out', keyframes([
        style({
          transform: 'translateX(340px)',
          offset: 0,
          opacity: 0,
        }),
        style({
          offset: .7,
          opacity: 1,
          transform: 'translateX(-20px)'
        }),
        style({
          offset: 1,
          transform: 'translateX(0)',
        })
      ]))),
      transition('active => removed', animate('500ms ease-in', keyframes([
        style({
          transform: 'translateX(-20px)',
          opacity: 1,
          offset: .2
        }),
        style({
          opacity: 0,
          transform: 'translateX(340px)',
          offset: 1
        })
      ])))
    ]),
  ],
})
export class ToasterAlertComponent extends Toast {
  undoString = 'undo';
  toastType: string = '';
  toastIcon: string = 'info';

  constructor(
      toastrService: ToastrService,
      toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
    this.setToastProperties();
  }

  setToastProperties() {
    switch (this.options.toastClass) {
      case 'toast-icon custom-toast-success':
        this.toastType = 'success-toast';
        this.toastIcon = 'done';
        break;
      case 'toast-icon custom-toast-warning':
        this.toastType = 'warning-toast';
        this.toastIcon = 'warning';
        break;
      case 'toast-icon custom-toast-error':
        this.toastType = 'error-toast';
        this.toastIcon = 'error';
        break;
      case 'toast-icon custom-toast-primary':
        this.toastType = 'primary-toast';
        this.toastIcon = 'info';
        break;
      case 'toast-icon custom-toast-secondary':
        this.toastType = 'secondary-toast';
        this.toastIcon = 'info';
        break;
      default:
        this.toastType = '';
        this.toastIcon = 'info';
        break;
    }
  }

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }
}
